import { render, staticRenderFns } from "./ICN003-04_info_warning.vue?vue&type=template&id=574660dc&"
import script from "./ICN003-04_info_warning.vue?vue&type=script&lang=js&"
export * from "./ICN003-04_info_warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports